import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
export default class AdyenDropIn
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...AdyenDropIn.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$configuration = {
            environment: this.DOM.$el.dataset[this.options.attrEnvironment],
            clientKey: this.DOM.$el.dataset[this.options.attrClientKey],
            analytics: {
                enabled: true
            },
            session: {
                id: this.DOM.$el.dataset[this.options.attrSessionId],
                sessionData: this.DOM.$el.dataset[this.options.attrSessionData]
            },
            paymentMethodsConfiguration: {
                card: {
                    positionHolderNameOnTop: true,
                    enableStoreDetails: this.DOM.$el.dataset[this.options.attrKassaEnableStorePaymentDetails] == 1,
                    hasHolderName: true,
                    holderNameRequired: true,
                    billingAddressRequired: false
                }
            },

            onPaymentCompleted: (result, component) => {
                // Make a request to Kassa's PaymentController to update the payment's
                // actions and its status
                switch(result.resultCode) {
                    case "Authorised":
                    case "Pending":
                    case "Received":
                    case "Refused":
                        let url = this.DOM.$el.dataset[this.options.attrKassaSubmitUrl];
                        window.axios.post(url, {'resultCode': result.resultCode});
                        break;
                    default:
                        break;
                }
                let qss = new URLSearchParams(result).toString();
                let ret =  this.DOM.$el.dataset[this.options.attrReturnUrl] + '?' + qss;

                // Give some time for the animation, but not too much
                // to avoid notifications arriving before this finishes
                setTimeout(() => {
                    window.location = ret;
                }, 3000);
            },
            onError: (error, component) => {
                component.setStatus('error', {message: 'Something went wrong, reload the page and try again in a few minutes.'});
            }
        };

        this.loadDropin();
    }

    async loadDropin() {
        const checkout = await AdyenCheckout(this.DOM.$configuration);
        const dropinComponent = checkout.create('dropin', {
            // Drop-in configuration only has props related to itself, like the onReady event.
            // Drop-in configuration cannot contain generic configuration like the onError event.
            showStoredPaymentMethods: false,
            onReady: () => {
                this.DOM.$el.querySelector('.c-wait').classList.add('u-hide');
            },
        });

        dropinComponent.mount(this.DOM.$el);
    }
}

AdyenDropIn.prototype.defaults = {
    attrEnvironment: 'adyenEnvironment',
    attrClientKey: 'adyenClientKey',
    attrSessionId: 'adyenSessionId',
    attrSessionData: 'adyenSessionData',
    attrReturnUrl: 'adyenReturnUrl',
    attrKassaEnableStorePaymentDetails: 'adyenEnableStoreDetails',
    attrKassaSubmitUrl: 'kassaSubmitUrl'
}
